<template>
  <div id="app">
    <Menu :isMobile="isMobile" @que-ver="queVer" :redes="redes" :opciones="optionNoticias" :see="see" @cambia-sel="cambiaSel"></Menu>
    <Institucional v-if="see == 'institucional'" :isMobile="isMobile"></Institucional>
    <Capacitaciones :capacitaciones="capacitaciones" v-if="see == 'capacitacion'"></Capacitaciones>
    <Noticias :noticias="noticias" v-if="see == 'noticias'" :cambia="elegido"></Noticias>
    <Manual v-if="see == 'manual'"></Manual>
    <FooterStatic :redes="redes"></FooterStatic>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import Noticias from './components/Noticias.vue'
import Capacitaciones from './components/Capacitaciones.vue'
import Manual from './components/Manual.vue'
import Institucional from './components/Institucional.vue'
import FooterStatic from './components/FooterStatic.vue'
import { store } from './store/store.js'
import bucketImage from '@/mixins/bucketImage.js'
import Axios from 'axios'
const ID_SHEET = '1auWKBVxPLjPVg71G9mugJqt4fDjWpuEFqk7r9lPcm44'
const GID = '0'
const GID2 = '719992898'
const urlNoticias = `https://olcreativa.lanacion.com.ar/dev/get_url/api.php?key2=${ID_SHEET}&gid=${GID}&output=json`
const urlCapacitaciones = `https://olcreativa.lanacion.com.ar/dev/get_url/api.php?key2=${ID_SHEET}&gid=${GID2}&output=json`

export default {
  name: 'app',
  data() {
    return {
      noticias: [],
      elegido: 'all',
      isMobile: false,
      see: store.see,
      redes: store.redes,
    }
  },
  mixins: [bucketImage],
  components: {
    Menu,
    Noticias,
    Capacitaciones,
    Manual,
    Institucional,
    FooterStatic,
  },
  created() {
    this.hideLoader()

    this.isMobile = window.innerWidth <= 600
    window.addEventListener(
      'resize',
      () => (this.isMobile = window.innerWidth <= 600),
    )
  },
  mounted() {
    this.showTitle()
    this.fetchData()
  },
  computed: {
    optionNoticias(){
      let opciones = []
      this.noticias.forEach((d) => {
        opciones.push(d.etiqueta)
      })
      let newOps = [...new Set(opciones)]
      return newOps
    }
  },
  methods: {
    queVer(e) {
      this.see = e
      store.see = e
    },
    cambiaSel(e) {
      this.elegido = e
    },
    
    fetchData() {
      Axios.all([Axios.get(urlNoticias), Axios.get(urlCapacitaciones)])
        .then(
          Axios.spread((...responses) => {
            this.noticias = responses[0].data
            this.capacitaciones = responses[1].data
          })
        )
        .catch(errors => {
          console.log(errors)
        })
    },
    showTitle() {
      const $title = document.querySelector('.scrl-titulo-wrapper')
      if ($title) $title.style.opacity = '1'
    },
    hideLoader() {
      const $loader = document.getElementById('preload')
      if ($loader) $loader.style.display = 'none'
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/_global.scss';

#app {
}
</style>
